import React, { useState } from 'react';
import { localDateString } from '../../utils/crmPipeline';

/**
 * Quick-action bar on a Today row. Call and Email log the activity (no task needed); Done and
 * Snooze operate on the lead's earliest open task, which the caller fetches on demand.
 */
const LeadActions = ({ onCall, onEmail, onDone, onSnooze, hasTask, busy }) => {
  const [snoozing, setSnoozing] = useState(false);
  const [date, setDate] = useState('');
  const minDate = localDateString(new Date(Date.now() + 86400000));
  const confirm = () => {
    if (!date) return;
    onSnooze(date);
    setSnoozing(false);
    setDate('');
  };
  return (
    <div className="crm-row-actions">
      <button type="button" className="crm-btn crm-btn-quiet crm-btn-sm" onClick={onCall} disabled={busy}>Call</button>
      <button type="button" className="crm-btn crm-btn-quiet crm-btn-sm" onClick={onEmail} disabled={busy}>Email</button>
      {hasTask && !snoozing && (
        <>
          <button type="button" className="crm-btn crm-btn-primary crm-btn-sm" onClick={onDone} disabled={busy}>Done</button>
          <button type="button" className="crm-btn crm-btn-quiet crm-btn-sm" onClick={() => setSnoozing(true)} disabled={busy}>Snooze</button>
        </>
      )}
      {hasTask && snoozing && (
        <>
          <input
            type="date"
            min={minDate}
            value={date}
            onChange={(e) => setDate(e.target.value)}
            aria-label="Snooze until"
            className="crm-input crm-input-sm"
          />
          <button type="button" className="crm-btn crm-btn-primary crm-btn-sm" onClick={confirm} disabled={!date || busy}>Set</button>
          <button type="button" className="crm-btn crm-btn-quiet crm-btn-sm" onClick={() => { setSnoozing(false); setDate(''); }}>Cancel</button>
        </>
      )}
    </div>
  );
};

export default LeadActions;
